module.exports = __WEBPACK_EXTERNAL_MODULE_67__;


/*****************
 ** WEBPACK FOOTER
 ** external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
 ** module id = 67
 ** module chunks = 0
 **/